export const AEM_ICC_UNREGISTRATION_TYPES = {
    CODENTIFY_ONLY: 'CODENTIFY_ONLY',
    ALL: 'ALL',
};
